import Styles from '../ElementsTab.module.scss'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { createShapeId, track } from '@tldraw/tldraw'
import { getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { GeoShapeProps } from 'components/VisualStudioPlayground/Shapes/GeoShape/Types'
import { MaskShapeProps } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { Element } from './Element'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ReactComponent } from 'react-hotkeys'
import {
  MASK_PLACEHOLDER_IMG_H,
  MASK_PLACEHOLDER_IMG_W,
} from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'

interface Props {
  shapesToDisplay: {
    label: string
    props: Partial<MaskShapeProps>
    component: ReactComponent
  }[]
}

const DEFAULT_MASK_PROPS = {
  w: 300,
  h: 300,
  mask: {
    // 300x300 is the size of the mask, so we show the image at the center
    topLeft: {
      x: (MASK_PLACEHOLDER_IMG_W - 300) / 2 / MASK_PLACEHOLDER_IMG_W,
      y: (MASK_PLACEHOLDER_IMG_H - 300) / 2 / MASK_PLACEHOLDER_IMG_H,
    },
    bottomRight: {
      x: ((MASK_PLACEHOLDER_IMG_W - 300) / 2 + 300) / MASK_PLACEHOLDER_IMG_W,
      y: ((MASK_PLACEHOLDER_IMG_H - 300) / 2 + 300) / MASK_PLACEHOLDER_IMG_H,
    },
  },
}

export const MaskShapesGrid = track(
  observer(({ shapesToDisplay }: Props) => {
    const editor = useEditor()
    const { drawersStore } = useRootStore()

    const insertMaskShape = (partialProps: Partial<GeoShapeProps>) => {
      if (!editor) return

      const frame = getCurrentFrame(editor)
      const props = {
        ...DEFAULT_MASK_PROPS,
        ...partialProps,
      }

      editor.batch(() => {
        const id = createShapeId()
        editor.createShape({
          id,
          type: 'mask',
          parentId: frame.id,
          x: frame.props.w / 2 - props.w / 2,
          y: frame.props.h / 2 - props.h / 2,
          props,
        })
        editor.select(id)
      })
      drawersStore.closeDrawer()
    }

    return (
      <div className={Styles.groupItems}>
        {shapesToDisplay.map((frame) => (
          <Element
            aria-label={frame.label}
            key={frame.label}
            onPress={() => {
              insertMaskShape(frame.props)
            }}
            shape={{
              type: 'mask',
              props: {
                ...DEFAULT_MASK_PROPS,
                ...frame.props,
              },
            }}
          >
            <frame.component />
          </Element>
        ))}
      </div>
    )
  }),
)
